export default function getClampedByStartDate(date: Date, minDate: Date): Date {
  if (date < minDate) {
    return minDate;
  }

  return date;
}
